import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Home'

function Routing() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/home' element={<Home/>}/>

                    <Route path='*' element={ <Home/> }/>
                    
                </Routes>
            </BrowserRouter>
        </>
    )
}

export default Routing
